import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { deleteAwayScheduleBlockV2 } from '@/services/deleteAwayScheduleBlockV2';
import {
  AWAY_SCHEDULE_QUERY_KEY,
  getAwayScheduleV2QueryOptions,
} from '@/services/getAwayScheduleV2';
import { userIdAtom } from '@/services/globalState';
import { replaceAwayPeriodV2 } from '@/services/replaceAwayPeriodV2';

export function useAwayScheduleQuery(options?: { enabled?: boolean }) {
  const userId = useAtomValue(userIdAtom);

  return useQuery({ ...getAwayScheduleV2QueryOptions(userId), enabled: options?.enabled });
}

/**
 * Settles by invalidating rather than patching the list, so a block the server
 * rejected or reshaped never lingers in the cache.
 */
export function useReplaceAwayPeriod() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: replaceAwayPeriodV2,
    onSettled: () => queryClient.invalidateQueries({ queryKey: AWAY_SCHEDULE_QUERY_KEY }),
  });
}

export function useDeleteAwayScheduleBlock() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAwayScheduleBlockV2,
    onSettled: () => queryClient.invalidateQueries({ queryKey: AWAY_SCHEDULE_QUERY_KEY }),
  });
}
